import { Component, effect, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PersonContactInfoStore } from './person-contact-info.store';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { PhoneInputComponent } from '../../../../../components/kit/input/phone-input/phone-input.component';
import { PasswordInputComponent } from '../../../../../components/kit/input/password-input/password-input.component';
import { EmailInputComponent } from '../../../../../components/kit/input/text-input/email-input.component';

@Component({
    selector: 'app-person-contact-info',
    templateUrl: './person-contact-info.component.html',
    providers: [PersonContactInfoStore],
    imports: [
        CardComponent,
        PhoneInputComponent,
        PasswordInputComponent,
        EmailInputComponent,
    ],
})
export class PersonContactInfoComponent {

    public readonly store = inject(PersonContactInfoStore);

    public form = input.required<FormGroup>();
    public personId = input<number | null>(null);
    public canEdit = input<boolean>(false);

    constructor() {
        effect(() => {
            const personId = this.personId();
            if (!personId) return;

            this.store.api.getPersonCommunicationPassword({ id: personId }).then((passwd) => {
                const form = this.form();
                if (!form.get('communikePassword')?.dirty) {
                    form.get('communikePassword')?.setValue(passwd.communikePassword);
                }
                form.controls.communikePassword.enable();
            });
        });
    }

    // async showCommunikePassword() {
    //     const personId = this.personId();
    //     if (!personId) return;
    //
    //     const passwd = await this.store.api.getPersonCommunicationPassword({ id: personId });
    //     const form = this.form();
    //     if (!form.get('communikePassword')?.dirty) {
    //         form.get('communikePassword')?.setValue(passwd.communikePassword);
    //     }
    //     form.controls.communikePassword.enable();
    // }
}
